import React, { useState, useRef } from 'react';
import { Upload, X, Loader2, Link as LinkIcon } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { adminApi } from '../context/AdminContext';

const ImageUpload = ({ value, onChange, label = "Image" }) => {
  const [uploading, setUploading] = useState(false);
  const [mode, setMode] = useState('url'); // 'url' or 'upload'
  const fileRef = useRef(null);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await adminApi.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      onChange(`${backendUrl}${response.data.url}`);
    } catch (error) {
      console.error('Upload failed:', error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium">{label}</label>
        <div className="flex gap-1">
          <Button type="button" variant={mode === 'upload' ? 'default' : 'ghost'} size="sm" className={mode === 'upload' ? 'bg-red-600 hover:bg-red-700 h-7 text-xs' : 'h-7 text-xs'} onClick={() => setMode('upload')}>
            <Upload className="h-3 w-3 mr-1" />Upload
          </Button>
          <Button type="button" variant={mode === 'url' ? 'default' : 'ghost'} size="sm" className={mode === 'url' ? 'bg-red-600 hover:bg-red-700 h-7 text-xs' : 'h-7 text-xs'} onClick={() => setMode('url')}>
            <LinkIcon className="h-3 w-3 mr-1" />URL
          </Button>
        </div>
      </div>

      {mode === 'url' ? (
        <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder="https://..." data-testid="image-url-input" />
      ) : (
        <div
          className="border-2 border-dashed rounded-lg p-4 text-center cursor-pointer hover:border-red-400 transition-colors"
          onClick={() => fileRef.current?.click()}
          data-testid="image-upload-dropzone"
        >
          <input ref={fileRef} type="file" className="hidden" accept="image/*" onChange={handleFileUpload} />
          {uploading ? (
            <div className="flex items-center justify-center gap-2 text-gray-500">
              <Loader2 className="h-5 w-5 animate-spin" />
              <span className="text-sm">Uploading...</span>
            </div>
          ) : (
            <div className="text-gray-500">
              <Upload className="h-8 w-8 mx-auto mb-2 text-gray-400" />
              <p className="text-sm">Click to upload image</p>
              <p className="text-xs text-gray-400 mt-1">JPG, PNG, WebP up to 10MB</p>
            </div>
          )}
        </div>
      )}

      {value && (
        <div className="relative inline-block">
          <img src={value} alt="Preview" className="rounded h-24 w-auto object-cover border" />
          <button type="button" onClick={() => onChange('')} className="absolute -top-2 -right-2 bg-red-600 text-white rounded-full p-0.5 hover:bg-red-700">
            <X className="h-3 w-3" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageUpload;
